import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useModal } from 'react-modal-hook'
import moment from 'moment'
import {
  accountsSelector,
  carouselCurrentItemSelector,
  getFeatureListSelector,
} from '../../../../selectors'
import Modal from '../../../../components/Modal/Modal'
import RequestService from '../../../../services/requests.service'
import BeneficiaryTransferService from '../../../../services/beneficiary-transfers.service'
import { CreateStandingInstructionSchema } from '../../../../schemas/requests'
import InputError from '../../../../components/InputError/InputError'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import { useTranslation } from 'react-i18next'
import { DIALOG_KEYS } from '../../../../utils/translation-constants'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../../components/FormComponents/NeoSuccess'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import NeoLoader from '../../../../components/FormComponents/NeoLoader'
import NumberFormat from 'react-number-format'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import AccountDisplay from '../../../../components/account-display/account-display'
import TermsAndConditions from '../../../../components/TermsAndConditions/TermsAndCondition'
import {
  VALIDATION_MESSAGES,
  SIDENAV_KEYS,
  REQUESTS_KEYS,
  BENEFICIARY_TRANSFER_KEYS,
} from '../../../../utils/translation-constants'
import config from 'custom/config/environment'

import validationConfig from 'custom/config/validation.config.json'
const siConfig = validationConfig['OtherService']['standingInstructions']

const todayDate = new Date().toISOString().split('T')[0]

function CreateStandingInstruction() {
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [selectedAccount, setSelectedAccount] = useState('')
  const [selectedBank, setSelectedBank] = useState('')
  const [otp, setOtp] = useState('')
  const [randomKey, setRandomKey] = useState('')
  const [terms, setTerms] = useState('')
  const [monthEnd, setMonthEnd] = useState(false)
  const [requestType, setRequestType] = useState('')
  const [banks, setBanks] = useState({})
  const [message, setMessage] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [verifyDetails, setVerifyDetails] = useState({})
  const history = useHistory()
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const accounts = useSelector(accountsSelector) || []
  const [formValues, setFormValues] = useState({
    requestType: '',
    debitAccountNumber: '',
    creditAccountNumber: '',
    bankName: '',
    branchName: '',
    startDate: '',
    endDate: '',
    date: '',
    month: '',
    year: '',
    siAmount: '',
    remarks: '',
    monthEndFlag: false,
    beneficiaryName: '',
  })
  const { t } = useTranslation()
  const transferTypes = {
    IAT: t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.INTERNAL),
    DDACC: t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.DDACC_TRANSFER),
    RTGS: t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.RTGS_TRANSFER),
  }

  const [error, setError] = useState('Error has Occurred')
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code}</b> : {error?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    fetchPreFormData()
  }, [])

  const fetchPreFormData = useCallback(async () => {
    try {
      const response = await BeneficiaryTransferService.getAllBanks()
      const bankNames = {}
      response.map((value) => {
        if (Object.keys(bankNames).includes(value.bankName)) {
          bankNames[value.bankName].push({
            bankCode: value.bankCode,
            address: value.branchDesc,
          })
        }
        bankNames[value.bankName] = [
          {
            bankCode: value.bankCode,
            address: value.branchDesc,
          },
        ]
        return value
      })
      setBanks(bankNames)
    } catch (err) {}
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm()
    }
  }

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)

      // var destAccDetails = {}
      // if (formValues.requestType === 'OAT') {
      //   destAccDetails = accounts.filter(
      //     (ele) => ele.accountNo === formValues.creditAccountNumber,
      //   )[0]
      // }
      const response = await RequestService.confirmCreateStandingInstruction({
        amount: formValues.siAmount,
        destAccount: formValues.creditAccountNumber,
        // destAccBranch:
        //   formValues.requestType === 'OAT'
        //     ? destAccDetails?.brnCode
        //     : verifyDetails?.destBranch,
        // destAccCcy:
        //   formValues.requestType === 'OAT' ? destAccDetails?.currency : verifyDetails?.destCurrency,
        destAccBranch: verifyDetails?.destBranch,
        destAccCcy: verifyDetails?.destCurrency,
        expireDate: formValues.endDate,
        firstValDate: formValues.startDate,
        monthEndFlag: formValues.monthEndFlag ? 'Y' : 'N',
        remarks: formValues.remarks,
        bankCode: formValues?.bankCode || '',
        srcAccount: currentAccountDetail?.accountNo,
        srcAccBranch: currentAccountDetail?.brnCode,
        srcAccCcy: currentAccountDetail?.currency,
        transferType: formValues.requestType,
        days: formValues.monthEndFlag ? '' : formValues.date || '',
        months: formValues.monthEndFlag ? '' : formValues.month || '',
        years: formValues.monthEndFlag ? '' : formValues.year || '',
        otp: otp,
        beneficiaryName:
          formValues.requestType === 'IAT' ? verifyDetails.beneName : formValues.beneficiaryName,
        destBankName: formValues?.bankName,
      })
      if (response.status === 200 || response.data.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [formValues, otp, banks, selectedBank, currentAccountDetail, verifyDetails])

  const onVerify = useCallback(
    async (values, { setSubmitting }) => {
      try {
        const featureDetails = featureList['SI_CREATE']
        if (featureDetails[currentAccountDetail['accountType']] === 'N') {
          setError({
            code: 'Access Denied',
            message:
              "You don't have permission with selected source Account. Try with different account.",
          })
          showModal()
          return
        }
        if (values.siAmount === '0.00' || values.siAmount === '.00') {
          return
        }
        setLoading(true)
        setSubmitting(true)
        let branchDetails = {}
        if (values.requestType !== 'IAT') {
          if (config.BENE_BRANCH && config.CLIENT_NAME !== 'NBS') {
            branchDetails = banks[values.bankName].filter(
              (ele) => ele.address === values.branchName,
            )[0]
          } else {
            branchDetails = banks[values.bankName][0]
          }
        }
        setFormValues({ ...values, ...branchDetails })
        var destAccDetails = {}
        // if (values.requestType === 'OAT') {
        //   destAccDetails = accounts.filter(
        //     (ele) => ele.accountNo === values.creditAccountNumber,
        //   )[0]
        // }

        const response = await RequestService.createStandingInstruction({
          amount: values.siAmount,
          destAccount: values.creditAccountNumber,
          destAccBranch: destAccDetails?.brnCode || '',
          destAccCcy: destAccDetails?.currency || '',
          expireDate: values.endDate,
          firstValDate: values.startDate,
          monthEndFlag: values.monthEndFlag ? 'Y' : 'N',
          remarks: values.remarks,
          bankCode: branchDetails?.bankCode || '',
          srcAccount: currentAccountDetail?.accountNo,
          srcAccBranch: currentAccountDetail?.brnCode,
          srcAccCcy: currentAccountDetail?.currency,
          transferType: values.requestType,
          days: values.monthEndFlag ? '' : values.date || '',
          months: values.monthEndFlag ? '' : values.month || '',
          years: values.monthEndFlag ? '' : values.year || '',
          beneficiaryName: values.beneficiaryName,
          destBankName: values?.bankName,
        })
        if (response.status === 200) {
          setStage(2)
          setLoading(false)
          setVerifyDetails(response.data)
          setOtpEnabled(response.data['otpEnable'])
          setSubmitting(false)
        }
      } catch (err) {
        setLoading(false)
        setSubmitting(false)
      }
    },
    [banks, showModal, currentAccountDetail, accounts, featureList],
  )

  function renderBankAddresses() {
    if (selectedBank.length > 0) {
      return banks[selectedBank].map((bank, i) => (
        <option key={i} value={bank.address}>
          {bank.address}
        </option>
      ))
    }

    return null
  }

  function renderCreditField(errors, touched) {
    // if (requestType === 'OAT') {
    //   if (currentAccountDetail) {
    //     const creditAccounts = accounts.filter(
    //       (value) => value.accountNo !== currentAccountDetail?.accountNo,
    //     )
    //     return (
    //       <div>
    //         <Field as='select' className='form-control' name='creditAccountNumber'>
    //           <option disabled value='' />
    //           {creditAccounts.map((acc, i) => (
    //             <option key={i} value={acc.accountNo}>
    //               {acc.accountNo}
    //             </option>
    //           ))}
    //         </Field>
    //         <InputError text={errors.creditAccountNumber} touched={touched.creditAccountNumber} />
    //       </div>
    //     )
    //   }
    //   return (
    //     <div>
    //       <Field as='select' className='form-control' name='creditAccountNumber'>
    //         <option disabled value='' />
    //       </Field>
    //       <InputError text={errors.creditAccountNumber} touched={touched.creditAccountNumber} />
    //     </div>
    //   )
    // }
    return (
      <div>
        <Field
          tabIndex={'2'}
          as='input'
          onKeyPress={(event) => {
            if (!(event.charCode >= 48 && event.charCode <= 57)) {
              event.preventDefault()
            }
          }}
          className='form-control'
          name='creditAccountNumber'
        />
        <InputError text={errors.creditAccountNumber} touched={touched.creditAccountNumber} />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE)}</div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formValues}
          enableReinitialize
          validationSchema={CreateStandingInstructionSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, handleChange, errors, values, touched, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.REQUEST_TYPE)}{' '}
                    {siConfig['isRequestTypeRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'1'}
                    as='select'
                    className='form-control'
                    name='requestType'
                    onChange={(e) => {
                      setRequestType(e.target.value)
                      handleChange(e)
                    }}>
                    <option disabled value='' />
                    {config.SI_TRANSFER_TYPES.map((option, index) => (
                      <option value={option} key={index}>
                        {transferTypes[option]}
                      </option>
                    ))}
                    {/* <option value='IAT'>
                      {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.INTERNAL)}
                    </option>
                    <option value='OAT'>
                      {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.OWN_ACCOUNT)}
                    </option> */}
                  </Field>
                  <InputError text={errors.requestType} touched={touched.requestType} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.CREDIT_ACCOUNT_NUMBER)}{' '}
                    {siConfig['isAccountNoRequired'] ? '*' : ''}
                  </label>
                  {renderCreditField(errors, touched)}
                </div>
              </div>

              {(values.requestType === 'DDACC' || values.requestType === 'RTGS') && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='3'
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BENEFICIARY_NAME)}
                      onChange={handleChange}
                      name='beneficiaryName'
                      value={values.beneficiaryName}
                      minLength={2}
                      maxLength={32}
                      onKeyPress={(event) => {
                        if (
                          !(event.charCode >= 65 && event.charCode <= 90) &&
                          !(event.charCode >= 97 && event.charCode <= 122) &&
                          event.charCode !== 32
                        ) {
                          event.preventDefault()
                        }
                      }}
                    />
                    <InputError text={errors.beneficiaryName} touched={touched.beneficiaryName} />
                  </div>
                </div>
              )}

              {(values.requestType === 'DDACC' || values.requestType === 'RTGS') && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <label className='control-label'>
                      {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BANK)}{' '}
                      {siConfig['isBankRequired'] ? '*' : ''}
                    </label>
                    <Field
                      tabIndex={'4'}
                      as='select'
                      className='form-control'
                      name='bankName'
                      onChange={(e) => {
                        setSelectedBank(e.target.value)
                        handleChange(e)
                      }}>
                      <option disabled value='' />
                      {Object.keys(banks).map((bankName, i) => (
                        <option key={i} value={bankName}>
                          {bankName}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.bankName} touched={touched.bankName} />
                  </div>
                  {config.BENE_BRANCH && (
                    <div className='form-group col-12'>
                      {config.CLIENT_NAME !== 'NBS' ? (
                        <>
                          <label className='control-label'>
                            {' '}
                            {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BRANCH)}{' '}
                            {siConfig['isBranchRequired'] ? '*' : ''}
                          </label>
                          <Field
                            tabIndex={'5'}
                            as='select'
                            className='form-control'
                            name='branchName'>
                            <option disabled value='' />
                            {renderBankAddresses()}
                          </Field>
                        </>
                      ) : (
                        <NeoInput
                          showAsterisk={siConfig['isBranchRequired']}
                          text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BRANCH)}
                          name='branchName'
                          value={values.branchName}
                          onChange={handleChange}
                        />
                      )}
                      <InputError text={errors.branchName} touched={touched.branchName} />
                    </div>
                  )}
                </div>
              )}

              <div className='row'>
                <div className='form-group col-6'>
                  <label className='control-label'>
                    {' '}
                    {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.START_DATE)}{' '}
                    {siConfig['isStartDateRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'6'}
                    as='input'
                    className='form-control'
                    type='date'
                    min={todayDate}
                    name='startDate'
                  />
                  <InputError text={errors.startDate} touched={touched.startDate} />
                </div>
                <div className='form-group col-6'>
                  <label className='control-label'>
                    {' '}
                    {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.END_DATE)}{' '}
                    {siConfig['isEndDateRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'7'}
                    as='input'
                    className='form-control'
                    type='date'
                    min={values.startDate || todayDate}
                    name='endDate'
                  />
                  <InputError text={errors.endDate} touched={touched.endDate} />
                </div>
                {config.MONTHEND && (
                  <div className='form-group col-12'>
                    <div className='form-check'>
                      <Field
                        tabIndex={'8'}
                        as='input'
                        type='checkbox'
                        className='form-check-input'
                        name='monthEndFlag'
                      />
                      <label className='form-check-label control-label' htmlFor='gridCheck'>
                        {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.MONTH_END)}
                      </label>
                    </div>
                  </div>
                )}
              </div>
              {!values.monthEndFlag ? (
                <div className='row'>
                  <div className='form-group col-4'>
                    <NeoInput
                      tabIndex={'8'}
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.DAYS)}
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('date', value?.value)
                      }}
                      name='date'
                    />
                    {/* <label className='control-label'>Days</label>
                    <Field
                      as='input'
                      type='number'
                      mode= 'onlyNumber'
                      className='form-control'
                      name='date'
                
                      onChange={(e) => {
                        if (parseInt(e.target.value) >= 0) {
                          setFieldValue('date', e.target.value)
                        }
                      }}
                    /> */}
                  </div>
                  <div className='form-group col-4'>
                    <NeoInput
                      tabIndex='9'
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.MONTHS)}
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('month', value?.value)
                      }}
                      name='month'
                    />
                    {/* <label className='control-label'>Month</label>
                    <Field
                      as='input'
                      type='number'
                      className='form-control'
                      name='month'
                      onChange={(e) => {
                        if (parseInt(e.target.value) >= 0) {
                          setFieldValue('month', e.target.value)
                        }
                      }}
                    /> */}
                  </div>
                  <div className='form-group col-4'>
                    <NeoInput
                      tabIndex='10'
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.YEARS)}
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('year', value?.value)
                      }}
                      name='year'
                    />
                    {/* <label className='control-label'>Year</label>
                    <Field
                      as='input'
                      type='number'
                      className='form-control'
                      name='year'
                      onChange={(e) => {
                        if (parseInt(e.target.value) >= 0) {
                          setFieldValue('year', e.target.value)
                        }
                      }}
                    /> */}
                  </div>
                  <div className='col-12'>
                    <InputError
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.VALIDATION_DAYS)}
                      touched={
                        (touched.date || touched.month || touched.year) &&
                        values.date == '' &&
                        values.month == '' &&
                        values.year == ''
                      }
                    />
                    <InputError
                      text={t(
                        REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.VALIDATION_MESSAGES,
                      )}
                      touched={
                        (touched.date || touched.month || touched.year) &&
                        (parseInt(values.date) <= 0 ||
                          parseInt(values.month) <= 0 ||
                          parseInt(values.year) <= 0)
                      }
                    />
                    <InputError
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.VALIDATION_DAYS)}
                      touched={
                        ((touched.date || touched.month || touched.year) &&
                          values.date.length > 0 &&
                          values.month.length > 0 &&
                          values.year.length > 0) ||
                        (values.date.length > 0 && values.month.length > 0) ||
                        (values.date.length > 0 && values.year.length > 0) ||
                        (values.month.length > 0 && values.year.length > 0)
                      }
                    />
                    <InputError
                      text={t(
                        REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS
                          .VALIDATION_DAYS_MONTH_YEAR,
                      )}
                      touched={
                        (touched.date || touched.month || touched.year) &&
                        (parseInt(values.date) > 365 ||
                          parseInt(values.month) > 24 ||
                          parseInt(values.year) > 5)
                      }
                    />
                  </div>
                </div>
              ) : null}
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='11'
                    showAsterisk={siConfig['isAmountRequired']}
                    mode='amount'
                    text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.SI_AMOUNT)}
                    onChange={(values) => {
                      setFieldValue('siAmount', values.value)
                    }}
                    name='amount'
                  />
                  <InputError text={errors.siAmount} touched={touched.siAmount} />
                  <InputError
                    text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                    touched={values.siAmount === '0.00' || values.siAmount === '.00'}
                  />
                  {/* <InputError
                    text={'Insufficient Balance in Selected Account'}
                    touched={parseInt(currentAccountDetail?.odBal) <= parseInt(values.siAmount)}
                  /> */}
                </div>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {' '}
                    {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.REMARKS)}{' '}
                    {siConfig['isRemarksRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'12'}
                    as='input'
                    className='form-control'
                    name='remarks'
                    minLength='2'
                    maxLength='40'
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.remarks} touched={touched.remarks} />
                </div>
              </div>
              <div className='mt-3'>
                {loading ? (
                  <NeoLoader />
                ) : (
                  <NeoButton
                    tabIndex='13'
                    mode={'newDesign'}
                    type='submit'
                    disabled={isSubmitting}
                    text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'14'}
                  onClick={() => history.goBack()}>
                  {' '}
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW)}</h3>

        <AccountDisplay currentAccountDetail={currentAccountDetail} />

        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.REQUEST_TYPE)}
          </h6>
          <h6 className='value'>
            {transferTypes[formValues.requestType]}
            {/* {formValues.requestType === 'IAT'
              ? t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.INTERNAL)
              : formValues.requestType === 'OAT'
              ? t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.OWN_ACCOUNT)
              : t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.DOMESTIC)} */}
          </h6>
        </div>
        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.CREDIT_ACCOUNT_NO)}
          </h6>
          <h6 className='value'>{formValues.creditAccountNumber}</h6>
        </div>
        {formValues.requestType !== 'IAT' && (
          <div>
            <div>
              <h6 className='label'>
                {' '}
                {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.QUICKPAY_BANK)}
              </h6>
              <h6 className='value'>{formValues.bankName}</h6>
            </div>
            {config.BENE_BRANCH && (
              <div>
                <h6 className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.QUICKPAY_BRANCH)}
                </h6>
                <h6 className='value'>{formValues.branchName}</h6>
              </div>
            )}
            <div>
              <h6 className='label'>
                {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BENEFICIARY_NAME_CONFIRM)}
              </h6>
              <h6 className='value'>{formValues.beneficiaryName}</h6>
            </div>
          </div>
        )}
        {formValues.requestType === 'IAT' && (
          <div>
            <div>
              <h6 className='label'>
                {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BENEFICIARY_NAME_CONFIRM)}
              </h6>
              <h6 className='value'>{verifyDetails.beneName}</h6>
            </div>
          </div>
        )}
        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.START_DATE)}
          </h6>
          <h6 className='value'>{moment(formValues.startDate).format('DD-MM-YYYY')}</h6>
        </div>
        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.END_DATE)}</h6>
          <h6 className='value'>{moment(formValues.endDate).format('DD-MM-YYYY')}</h6>
        </div>
        {!formValues.monthEndFlag ? (
          <div>
            {formValues.date && (
              <div>
                <h6 className='label'>
                  {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.DAYS)}
                </h6>
                <h6 className='value'>{formValues.date || '-'}</h6>
              </div>
            )}

            {formValues.month && (
              <div>
                <h6 className='label'>
                  {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.MONTHS)}
                </h6>
                <h6 className='value'>{formValues.month || '-'}</h6>
              </div>
            )}

            {formValues.year && (
              <div>
                <h6 className='label'>
                  {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.YEARS)}
                </h6>
                <h6 className='value'>{formValues.year || '-'}</h6>
              </div>
            )}
          </div>
        ) : null}
        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.AMOUNT)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues.siAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>

        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.REMARKS)}</h6>
          <h6 className='value'>{formValues.remarks}</h6>
        </div>
        {config.MONTHEND && (
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.MONTH_END)}{' '}
              {formValues.monthEnd}
            </h6>
            <h6 className='value'>
              {formValues.monthEndFlag
                ? t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.YES)
                : t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.NO)}
            </h6>
          </div>
        )}
        <div>
          <TermsAndConditions module='STANDINGINSTRUCTION' />
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.CONFIRM)}
              mode={'newDesign'}
              onClick={() => (otpEnabled ? setStage(3) : onConfirm)}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {' '}
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='SI_CREATE'>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}

export default CreateStandingInstruction
